
import {
  defineComponent,
  ref,
  computed,
  Ref,
  watch,
} from 'vue';
import DateOfCalendar from '@/class/DateOfCalendar';
import PostEditor from '@/components/DateDetail/PostEditor.vue';
import useQueryPostApi from '@/composables/useQueryPostApi';
import PostsQueryInput from '@/interface/graphql/PostsQueryInput';
import SvgIcon from '@/components/SvgIcon.vue';
import { useStore } from '@/store';
import useTogglePhoto from '@/composables/useTogglePhoto';

export default defineComponent({
  components: { PostEditor, SvgIcon },
  props: {
    dateString: {
      type: String,
      required: true,
    },
  },
  name: 'DateDetail',
  setup(props) {
    // const monthList = ['一 月', '二 月', '三 月', '四 月', '五 月', '六 月', '七 月', '八 月', '九 月', '十 月', '十一月', '十二月'];
    const monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    // const weekList = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    // const weekList = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const weekList = ['Sunday // 星期日', 'Monday // 星期一', 'Tuesday // 星期二', 'Wednesday // 星期三', 'Thursday // 星期四', 'Friday // 星期五', 'Saturday // 星期六'];
    const dateOfCalendar = new DateOfCalendar();
    dateOfCalendar.date = new Date(props.dateString);
    const currentDate = ref(dateOfCalendar);
    const store = useStore();

    const variable: Ref<PostsQueryInput> = ref({
      from: props.dateString,
      to: props.dateString,
    });

    const { posts, refetch, loading } = useQueryPostApi(variable);

    const currentPostIndex = ref(0);
    const currentPost = computed(() => (posts.value.length > 0) ? posts.value[currentPostIndex.value] : null);

    watch(
      () => currentPost.value,
      () => {
        store.state.photosInCarousel = currentPost.value ? currentPost.value.photos : [];
      },
      { deep: true },
    );

    const isNewPost = ref(false);

    const clickPost = (index: number) => {
      if (index >= 0 && index < posts.value.length) {
        currentPostIndex.value = index;
        isNewPost.value = false;
      }
    };

    const clickAddPost = () => { isNewPost.value = true; };

    const { showPhoto } = useTogglePhoto();

    document.onkeydown = (e) => {
      e = e || window.event;
      const arrowUp = 38;
      const arrowDown = 40;
      if (e.keyCode === arrowUp) {
        clickPost(currentPostIndex.value - 1);
      } else if (e.keyCode === arrowDown) {
        clickPost(currentPostIndex.value + 1);
      }
    };

    return {
      currentDate,
      posts,
      currentPostIndex,
      currentPost,
      monthList,
      weekList,
      isNewPost,
      clickPost,
      clickAddPost,
      refetch,
      loading,
      showPhoto,
    };
  },
});
